module.exports = __webpack_public_path__ + "img/今天.bae883de.png";